module.exports = __webpack_public_path__ + "img/contentbox_bg.29ca7ad6.png";